/**
 * user模块接口列表
 */
// 验证码登录接口列表：http://rap2.10niu.cn/repository/editor?id=21&mod=64&itf=4080
import requestByGateway from '@/request/request.gateway';
import requestByBasic from '@/request/request.basic';
import config from '@/config';
import qs from 'qs';

const user = {
	/**
	 * 用户名登录
	 */
	loginByUsername(data) {
		return requestByGateway({
			method: 'post',
			// url: `${config.api.admin}/login`,
			url: `${config.api.admin}/v2/login`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取header-bar
	 */
	getMenuMapSort() {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/menu/get-menu-category-list`,
			data: qs.stringify({})
		});
	},
	/**
	 * 获取sidebar
	 */
	getMenuMap(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/menu/user-menu`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 旧版登录
	 */
	loginByUsernameOld(data) {
		return requestByBasic({
			method: 'post',
			url: `${config.api.ps}/School/User/authenticate`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 旧版后台退出登录
	 */
	logoutOld() {
		console.log('jin', window.document.cookie);
		return requestByBasic({
			method: 'get',
			url: 'https://ps.10niu.cn/PS-develop/School/user/logout?from=v2'
		});
	},
	/**
	 * 旧版登录token
	 */
	loginTokenOld(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/token/getToken`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取下载任务（网关）
	 */
	getDownloads(data) {
		return requestByGateway({
			method: 'get',
			params: data,
			url: `${config.api.pos}/consume/export/list`
		});
	},
	/**
	 * 刷新token
	 */
	refreshToken() {
		return requestByGateway({
			method: 'get',
			url: `${config.api.uc}/XBullUCenter/user/IDToken/refreshToken`
		});
	},
	/**
	 * 获取用户基本信息
	 */
	getUserInfo() {
		return requestByGateway({
			method: 'get',
			url: `${config.api.uc}/XBullUCenter/user/IDToken/myUserInfo`
		});
	},
	/**
	 * 更新用户信息
	 */
	updateProfile(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.uc}/UCenter/Profile/editProfile`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 重置密码
	 */
	resetPassword(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.uc}/UCenter/Profile/resetPassword`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据域名获取logo图片
	 */
	getLogoByDamin(data) {
		return requestByGateway({
			method: 'post',
			url: `${
				config.api.schoolstruct
			}/schoolstruct/interior/oem/get_oem_by_domain`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 验证码_创建
	 */
	createCode() {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/captcha/create`
		});
	},
	/**
	 * 验证码_重置
	 */
	refreshCode(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/captcha/refresh`,
			data: qs.stringify(data)
		});
	}
};

export default user;
